import React, { useState } from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import {
  CloseButton,
  ModalFlex,
  ModalHeader,
  ModalHeaderLabel,
} from '../../components/Template/Modal'
import Button from '../../components/Template/Button'
import { is } from '../../components/MediaQuery'
import closeModal from '../../actions/Modals/closeModal'
import { ServicesModalWrapper } from '../../components/Calendar/ReservationModal'
import { NumberInput } from '../../components/FormBuilder'
import useSize from '../../hooks/useSize'

function UpdateModal({
  open,
  modalId,
  edit,
  prepayment,
  close,
  index,
}: {
  open?: boolean
  modalId?: string
  close?: any
  index?: any
  edit?: any
  prepayment?: any
}) {
  const { t } = useTranslation()
  const isDesktop = is.desktop()
  const size = useSize()

  function onClose() {
    close(modalId)
  }

  const [percent, setPercent] = useState(prepayment.percent)
  const [days, setDays] = useState(prepayment.days)

  const editP = () => {
    edit(index, percent, days)()
    onClose()
  }

  return (
    <ModalFlex
      style={{ marginBottom: isDesktop ? '50vh' : 0 }}
      open={open}
      onClose={onClose}
    >
      <ServicesModalWrapper>
        <ModalHeader
          style={{ padding: `${size}em ${0.4 * size}em 0px ${1.3 * size}em` }}
        >
          <Flex style={{ width: '100%' }} justifyStart={true}>
            <ModalHeaderLabel size={size}>
              {t('BBO_2884_prepayment_edit')}
            </ModalHeaderLabel>
          </Flex>
          <Flex style={{ width: '100% ' }} justifyEnd={true} alignCenter={true}>
            <CloseButton size={size} onClose={onClose} />
          </Flex>
        </ModalHeader>
        <Flex
          column={true}
          style={{
            fontSize: `${16 * size}px`,
            padding: `${10 * size}px ${1.3 * size}em ${10 * size}px ${1.3 *
              size}em`,
          }}
        >
          <Flex column={!isDesktop} row={isDesktop} alignEnd={isDesktop}>
            <NumberInput.Field
              name={'percent'}
              size={size}
              value={percent}
              wrapperStyle={{
                width: isDesktop ? '50%' : '100%',
              }}
              onFocus={() => {}}
              onChange={setPercent}
              onlyInteger={true}
              withoutPicker={true}
              minValueForNumber={0}
              maxValueForNumber={100}
              inputStyle={{
                paddingRight: '25px',
                textAlign: 'right',
              }}
              withAfterIcon={
                <div style={{ fontSize: '14px', opacity: '0.6' }}>%</div>
              }
              label={t('BBO_1494_percent')}
            />
            <NumberInput.Field
              onChange={setDays}
              disabled={index === 0}
              value={days}
              wrapperStyle={{
                marginLeft: isDesktop ? '20px' : '0px',
                width: isDesktop ? '40%' : '100%',
              }}
              onFocus={() => {}}
              wrapWithTextAfter={t('days')}
              justifyCenter={false}
              onlyInteger={true}
              minValueForNumber={0}
              name={'days'}
              size={size}
              label={t('BBO_2884_prepayment_days')}
            />
          </Flex>
          <Button
            disabled={typeof percent === 'string'}
            isDisabled={typeof percent === 'string'}
            onClick={editP}
            primary={true}
            style={{ marginTop: '15px' }}
          >
            {t('save')}
          </Button>
        </Flex>
      </ServicesModalWrapper>
    </ModalFlex>
  )
}

export default connect(
  null,
  dispatch => ({
    close: id => dispatch(closeModal(id)),
  }),
)(UpdateModal)
